/* @flow */
import styled from 'styled-components'
import WMContainer from '@website/common/components/WMContainer'
import { white } from '@website/common/styles/colors'

export const WMCustomContainer = styled(WMContainer)`
  padding: 40px 60px;
  word-break: break-word;
  background: #F3F3F3;
  width: 100%;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 100%;
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
    padding: 24px 20px;
  }
  @media only screen and (max-width: 458px) {
    padding-top: 12px;
    padding-bottom: 12px;
  }
`

export const Text = styled.p`
  position: relative;
  color: #333333;
  font-size: 18px;
  line-height: 1.3;
  margin: 0 40px 0 32px;
  padding-left: 32px;
  @media only screen and (max-width: 1024px) {
    font-size: 16px;
    text-align: center;
    padding: 0;
    margin: 0 0 20px 0;
  }
  @media only screen and (max-width: 458px) {
    margin-bottom: 12px;
    font-size: 14px;
  }
  &:before {
    content: '';
    position: absolute;
    left: 0;
    width: 1px;
    top: 0;
    bottom: 0;
    background-color: #333333;
    @media only screen and (max-width: 1024px) {
      display: none;
    }
  }
  
`

export const Bold = styled.span`
  font-weight: 600;
`

export const LeftContent = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
  }
`

export const LogoWrapper = styled.div`
  max-width: 208px;
  width: 100%;
  @media only screen and (max-width: 1024px) {
    max-width: 200px;
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 458px) {
    max-width: 130px;
    margin-bottom: 12px;
  }
  img {
    width: 100%;
  }
`

export const Button = styled.button`
  background: #1975DD;
  color: ${white};
  padding: 20px 132px;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  outline: none;
  user-select: none;
  cursor: pointer;
  border: none;
  border-radius: 12px;
  line-height: 17px;
  white-space: nowrap;
  @media only screen and (max-width: 1360px) and (min-width: 1025px) {
    padding-right: 90px;
    padding-left: 90px;
  }
  @media only screen and (max-width: 458px) {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    font-size: 16px;
    border-radius: 8px;
  }
  &:hover {
     background: #025BC0;
  }

`
